import { Box, Typography } from "@mui/material";
import styled from "@emotion/styled";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS } from "@contentful/rich-text-types";

import { PAGE_MODULES } from "enums/pageModules";
import PagePresenter from "presenters/PagePresenter";
import { getImageUrl } from "utils/imageHandlerUtils";

const Banner = styled("div")(
  ({ theme, mobileImageBanner, desktopImageBanner, backgroundColor, backgroundGradientColor }) => ({
    width: "100%",
    textAlign: "center",
    padding: "15px 0",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    position: "relative",
    background: backgroundGradientColor
      ? `linear-gradient(to bottom, ${backgroundColor || "transparent"}, ${backgroundGradientColor})`
      : backgroundColor || "transparent",
    "&::after": {
      width: "100%",
      height: "100%",
      content: '""',
      position: "absolute",
      backgroundImage: `url(${getImageUrl(mobileImageBanner, {})})`,
      backgroundPosition: "center top",
      backgroundRepeat: "no-repeat",
    },
    [theme.breakpoints.up("mobile")]: {
      "&::after": {
        backgroundImage: `url(${getImageUrl(desktopImageBanner, {})})`,
      },
      padding: "20px 0",
    },
    ".subtitle": {
      fontWeight: theme.typography.fontWeightRegular,
    },
  }),
);

const CategoryTitleBanner = ({ page }) => {
  const title = PagePresenter.title(page);
  const { subheader } = page;
  const categoryHero = page?.pageModules?.find((pageModule) => pageModule.type === PAGE_MODULES.CATEGORY_HEROES) || {};
  const {
    backgroundImageMobile,
    backgroundImageDesktop,
    backgroundColor,
    backgroundGradientColor,
    headerColor,
    subheaderColor,
  } = categoryHero;

  const subheaderText = documentToReactComponents(subheader, {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_node, children) => (
        <Typography variant="h5" component="p" className="subtitle" color={subheaderColor || "black"}>
          {children}
        </Typography>
      ),
    },
  });

  return (
    <Banner
      data-testid="banner"
      mobileImageBanner={backgroundImageMobile}
      desktopImageBanner={backgroundImageDesktop}
      backgroundColor={backgroundColor}
      backgroundGradientColor={backgroundGradientColor}
    >
      <Box sx={{ zIndex: 1 }}>
        <Typography variant="h1" color={headerColor || "black"}>
          {title}
        </Typography>
        {subheaderText}
      </Box>
    </Banner>
  );
};

CategoryTitleBanner.propTypes = {
  page: PagePresenter.shape(),
};

export default CategoryTitleBanner;
